export class CommonConstants {
    public static DEFAULT_EMPTY_STRING = '';
    public static ONLY_ALPHABETS_PATTERN_STRING: any = /^([a-zA-Z])$/;
    public static URL_SEPARATOR = '/';
    public static PIPE_SEPARATOR = '|';
    public static QUERY_PARAMETER_LITERAL = '?';
    public static EQUALS = '=';
    public static AMPERSAND = '&';
    public static PERCENTAGE_LITERAL = '%';
    public static EMAIL_PATTERN_STRING = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
    public static DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again later';
    public static DISCLAIMER_TEXT = 'Issuance of policy is subject to successful validation of your KYC details.'
    public static InsProductType = 'HLTHCOMBO';
    public static EMIOTPNEXTTASKKEY = 'emiOtpPage';
    public static DEFAULT_PLAN_TYPE_BFL = 'Comprehensive';
    public static DEFAULT_PLAN_TYPE_BFDL = 'Base Plan';
    public static DEFAULT_SOURCETYPE = 'JOURNEY';
    // timer value in seconds
    public static SESSIONEXPIRYTIMER = 30;
    // timeout value in minutes
    public static appIdleTimeout: number = 30;
    public static PersonCodes = {
        Proposer: 1,
        ProposerInsured: 2,
        Spouse: 3,
        Child1: 4,
        Child2: 5,
        Child3: 6,
        Child4: 7,
        Father: 8,
        Mother: 9,
        FatherInLaw: 10,
        MotherInLaw: 11
    };

    // Cookie Keys
    public static CookieKeys = {
        AuthId: 'authId',
        NTID: 'NTID',
        AuthType: 'authType',
        State: 'state',
        Code: 'code',
        AuthToken: 'authToken',
        ProcessInstanceDetails: 'processInstanceDetails',
        LoanApplicationId: 'loanApplicationId',
        LoanApplicationKey: 'loanApplicationKey',
        Error: 'error',
        UserName: 'uDetails',
        DeviceDetails: 'DeviceDetails',
        ClientId: 'SC_ID',
        SecretKey: 'SS_ID',
        UserAuthenticationToken: 'UserAuthenticationToken',
        GeoLocationDetails: 'GeoLocationDetails',
        JWToken: 'SS_1',
        GuardToken: 'SS_2',
        GuardKey: 'SS_4',
        EmployeeResume: 'SS_R_TYP',
        EmployeeResume_Value: 'emp',
        IsLaIsPh: 'IsLaIsPh',
        MobileState: 'mobileState',
        PaymentSuccess: 'paymentSuccess',
        JourneyType: 'journeytype',
        PaymentRedirect: 'paymentRedirect',
        InsProductType: 'insProductType',
        InsuranceProductType: 'insuranceProductType',
        processId: 'processId',
        applicationId: 'applicationId',
        personCode: 1,
        addressCode: 1,
        planQuoteCriteriaData: 'planQuoteCriteriaData',
        quoteId: 'quoteId',
        orderId: 'orderId',
        NextTaskKey: 'NextTaskKey',
        NextTaskKeyProposerToInsurer: 'NextTaskKeyProposerToInsurer',
        NextTaskKeyOmHR: 'NextTaskKeyOmHR',
        addressValue: 'addressValue',
        isPlanSelected: 'isPlanSelected',
        NomineeID: 'NomineeID',
        selectedQuoteId: 'selectedQuoteId',
        addressId: 'addressId',
        principalId: 'principalId',
        selectedPlanCode: 'selectedPlanCode',
        principalCode: 'principalCode',
        panIndiaCoverage: 'panIndiaCoverage',
        SelfGender: 'selfGender',
        SelfDob: 'selfDob',
        planPremiumChange: 'planPremiumChange',
        JWTokenEP: 'EP_SS_1',
        GuardTokenEP: 'EP_SS_2',
        GuardKeyEP: 'EP_SS_4',
        showAdditionalDetails: 'showAdditionalTab',
        proposerAdditionalDetails: 'proposerAdditionalDetails',
        proposerOtherDetails: 'proposerOtherDetails',
        showBankDetails: 'showBankDetails',
        AdditionalDetails: 'additionalDetails',
        showMailingAdditionalDetails: 'showMailingAdditionalDetails',
        mailingAddressDetails: 'mailingAddressDetails',
        showInsuredAdditionalDetails: 'showInsuredAdditionalDetails',
        InsurerSessionData: 'insurerSessionData',
        principalKey: 'principalKey',
        prevPanIndiaCoverage: 'prevPanIndiaCoverage',
        variantCode: 'variantCode',
        selectedPlanType: 'selectedPlanType',
        selectedAggregateDeductible: 'selectedAggregateDeductible',
        sessionId: "X-Session-Token",
        bflJourney: 'bflJourney',
        groupHealthEligible: 'groupHealthEligible',
        cityName: 'cityName',
        PSVToken: 'Customer_SS_1', // Psuedo verified customer token
        latitude: 'latitude',
        longitude: 'longitude',
        platform: 'platform',
        epTokenDetails: 'EP_TK',
        epUserDetails: 'EP_UD',
        backFlow: 'backFlow',
        widget: {
            processId: 'h_widget_processId',
            applicationId: 'h_widget_applicationId',
            quoteId: 'h_widget_quoteId',
            JWToken: 'h_widget_SS_1',
            GuardToken: 'h_widget_SS_2',
            GuardKey: 'h_widget_SS_4',
            groupHealthEligible: 'h_widget_groupHealthEligible',
            planQuoteCriteriaData: 'h_widget_planQuoteCriteriaData'
        },
        sdkVersion: 'sdk_version',
        useResp: 'useResp',
        CKYC_Customer_SS_1: 'CKYC_Customer_SS_1',
        utm_medium_3in1: 'utm_medium_3in1',
        full_name: 'full_name',
        dateOfBirth: 'dateOfBirth',
        gender: 'gender',
        email: 'email',
        mobile_number: 'mobile_number',
        pin_code: 'pin_code',
        isClaim: 'IsClaim',
        ssoEnabled: 'ssoEnabled',
        isMobile: 'isMobile',
        NextTaskKeyCLP: 'NextTaskKeyCLP',
        clpLandingPage: 'clpLandingPage',
        CKYC_Application_Id: 'CKYC_Application_Id'
    };

    public static LOAN_PRODUCT_CODES = {
        Secured_Personal_Loan: 'DHB',
        Secured_Loan: 'SSL',
        Travel_Insurance: 'TGI',
        Health_Insurance: 'HGI',
        Cyber_Insurance: 'CGI',
        Health_ExtraInsurance: 'HTP',
        Motor_Insurance: 'MGI',
        HealthCombo_Insurance: 'HLTHCOMBO',
        // li
    };
    public static LOAN_PRODUCT_CATEGORY_CODES = {
        Unsecured_Loan: 'UL',
        Secured_Loan: 'SL',
        Travel_Insurance: 'ins',
        Health_Insurance: 'ins',
        Cyber_Insurance: 'ins',
        Health_ExtraInsurance: 'HGI',
        Motor_Insurance: 'ins',
        HealthCombo_Insurance: 'HGI'
    };
    public static APPLICANT_PHONE_TYPES = {
        Mobile: 'MOBILE',
        Fax: 'FAX',
        General: 'GENERAL',
        HomeFax: 'HOMEFAX',
        HomePhone: 'HOMEPHN',
        Office: 'OFFICE',
        SmsMobile: 'SMSMOB',
        Work: 'WORK'
    };
    public static APPLICANT_EMAIL_TYPES = {
        CoApplicant_1: 'CO-BOR1',
        CoApplicant_2: 'CO-BOR2',
        Communication: 'COMM',
        Guardian: 'GUARDIAN',
        Husband: 'HUSBAND',
        Nominee: 'NOMINEE',
        Office: 'OFFICE',
        Other: 'OTHER',
        Parent: 'PARENT',
        Personal_1: 'PERSON1',
        Personal_2: 'PERSON2',
        Wife: 'WIFE',
        Work: 'WORK'
    };
    public static UploadType = {
        Aadhar: 'Aadhar',
        Passport: 'Passport',
        BankStatement: 'BankStatement',
        Pan: 'Pan',
        DL: 'DL'
    };
    public static encyKey = {
        keyToEncrypt: 'B1729a411698j58260a613355j556900'
    };
    public static QueryParamsKeys = {
        EmailToConfirmType: 'type',
        EmailTokenToConfirm: 'id',
        PaymentStatus_QueryParams: 'queryParams',
        appUtmRefCode: 'appUtmRefCode',
        appUtmSource: 'appUtmSource',
        appUtmMedium: 'appUtmMedium',
        appUtmCampaign: 'appUtmCampaign',
        appUtmTerm: 'appUtmTerm',
        appUtmContent: 'appUtmContent',
        UTMData: 'UTMData',
        BFLBranch: 'BFLBranch',
        GCLID: 'gclid',
        Productcode: 'prdcode',
        Product: 'product',
        ApplicantId: 'apcantid',
        ApplicationId: 'aptionid',
        ApplicationApplicantId: 'apcaptid',
        InsuranceProductType: 'insuranceProductType',
        IsMobile: 'isMobile',
        journeySource: 'source',
        applicationId: 'applicationid',
        productCode: 'product_code',
        product: 'product',
        InsProductType: 'insProductType',
        ShowOnlyGroupPlan: 'showOnlyGroupPlan',
        marketplace: 'marketplace',
        route: 'route',
        isDark: 'isDark',
        paymentId: 'paymentId',
        utmSource: 'utm_source',
        res: 'res'
    };
    public static SharedServiceDataKeys = {
        JourneySource: 'JourneySource',
        Applicant: 'Applicant',
        AadharNumber: 'AadharNumber',
        ProgressStateInfo: 'ProgressStateInfo',
        EsignDocmentList: 'esignDocmentList',
        IsNewApplication: 'IsNewApplication',
        ApplicationID: 'ApplicatonID',
        WebsiteResumeMobileNumber: 'WebsiteResumeMobileNumber',
    };
    // Routes
    public static Routes = {
        Home: '',
        MultitabFailed: 'multitabfailed',
        Application: {
            Home: 'applicationStage',
            EditDetails: 'editDetails',
            PremiumPayer: 'premiumPayer',
            childEducationDetail: 'childEducationDetail',
            nomineeDetails: 'nomineeDetails',
            AddressDetails: 'addressNomineeDetails',
            EducationDetails: 'educationDetails',
            RenewApplication: 'renewApplication',
            EmploymentDetails: 'employmentDetails',
            AdditionalDetails: 'additionalDetails',
            SetPortfolio: 'setPortfolio',
            ApplicationStatus: 'applicationStatus',
            EditVehicleRegistration: 'editVehicleRegistration',
            VehicleDetails: 'vehicleDetails',
            QuickQuestions: 'revampQuickQuestionDetails',
            GetGoingNow: 'getGoingNow',
            GetGoingNowEdit: 'getGoingNowEdit',
            InsurerDetails: 'insurerDetails2',
            AbhiAdditionalDetail: 'abhiadditionalDetail',
            BagicAdditionalDetail: 'BagicadditionalDetail',
            OtherAdditionalDetail: 'otheradditionalDetail',
            JourneyOtpVerification: 'journeyOtpVerification',
            Congratulations: 'congratulations',
            InsPolicyPage: 'insPolicyPage',
            PaymentFailed: 'paymentFailed',
            PendingPaymentPage: 'pendingPaymentPage',
            RetryPaymentPage: 'retryPaymentPage',
            PaymentStatus: 'paymentStatus',
            quoteConsentOtp: 'quoteConsentOtp',
            paymentInitiate: 'paymentInitiate',
        },
        ApplicationModule: {
            PlanDetail: 'planDetail',
        },
        DetailsModule: {
            ProposerPersonalDetails: 'proposerPersonalDetails',
        },
        InsuredModule: {
            InsurerDetails: 'insurerDetails',
        },
        AdditionalApplication: {
            Home: 'additionalDetails',
            BankDetails: 'bankDetails',
            EAccountDetails: 'eAccountDetails',
            FatcaDeclaration: 'fatcaDeclaration',
            IfscFinder: 'ifscFinder',
            TravelDetails: 'travelDetails',
            FamilyChildInsurance: 'familyChildInsurance',
            LifestyleDetails: 'lifestyleDetails',
            HealthRecordDetails: 'healthRecordDetails'
        },
        Verification: {
            Home: 'verify',
            VerifyMobile: 'verifyMobile'
        },
        FinalModule: {
            UploadDocument: 'uploadDocument',
            RejectApplication: 'rejectApplication',
            PaymentReview: 'paymentReview',
            ProductReview: 'productReview',

        },
        QuestionnaireModule: {
            MoreAboutDetails: 'moreAboutDetails',
            MedicalDeclaration: 'medicalDeclaration',
            MoreAboutYou: 'moreaboutyou',
        },
        Logout: 'logout',
        ResumeApplication: 'resumeApplication',
        ApplicationList: 'applicationList',
        CustomerLogin: 'customerLogin',
        CustomerLoginBase: 'customerLogin',
        otp: 'otpverification'
    };
    // input type
    public static InputTypes = {
        ReadOnly: 'ReadOnly',
        Selection: 'Selection',
        Dynamic: 'Dynamic',
        Button: 'Button',
        Date: 'Date',
        Boolean: 'Boolean',
        InputBox: 'InputBox',
        CheckBox: 'boolean'
    };
    // APIURL
    public static APIURL = {
        ABTESTLAYOUT: 'l1',
        getGeoLocationBasedOnPin: '{DOMAIN01}/v2/referencedata/locations/{0}',
        getGeoLocationBasedOnCityId: '{DOMAIN01}/v2/referencedata/locations/city/{0}',
        startApplicationActiviti: '{DOMAIN01}/v2/insurances/health/workflow/process',
        completeActivitiTask: '{DOMAIN01}/v2/insurances/health/workflow/process',
        getActivitiTaskDetails: '{DOMAIN01}/v2/insurances/health/workflow/details',
        getResumeTokenForUser: '{DOMAIN01}/v2/logins/ui',
        getTokenForUser: '{DOMAIN01}/v2/logins/ui',
        getPaymentDetails: '{DOMAIN01}/v1/insurance/business/payments/pgateways/initiate',
        getRelationship: '{DOMAIN01}/v1/referencedata/applicants/relationshipscodes',
        downloadPdf: '{DOMAIN01}/v1/documentmanagement/exportpdf',
        downloadReciept: '{DOMAIN01}/v1/insurances/health/{applicationId}/payments/receipts',
        getNomineeRelationshipLookupService: '{DOMAIN01}/v1/insurance/products/relationgroups/OMHLNOMINEEREL',
        resumeSendOtp: '{DOMAIN01}/v1/logins/forms/mobile',
        resumeGetOtp: '{DOMAIN01}/v1/logins/forms/mobile/otp',
        postPaymentStatus: '{DOMAIN01}/v1/insurance/business/payments/pgateways/postpayment',
        getPaymentStatus: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/payments/status',
        getHealthRequestId: '{DOMAIN01}/v1/insurances/booking/initiation',
        validatePersonalEmailID: '{DOMAIN01}/v1/referencedata/checkdomain?email={0}',
        inquiries: '{DOMAIN01}/v2/insurances/health/inquiry',
        rtos: '{DOMAIN01}/v1/referencedata/insurances/health/rtos',
        getVehicleList: '{DOMAIN01}/v1/insurances/health/vehicles?text=',
        emicardeligibiltyservice: '{DOMAIN01}/v1/insurance/business/payments/emicards/eligibility',
        addWhatsappConsent: '{DOMAIN01}/v1/whatsapp/addconsent',
        getWhatsappConsent: '{DOMAIN01}/v1/whatsapp/getconsent',
        addPartnerConsent: '{DOMAIN01}/v1/whatsapp/partner/addconsent',
        postCall: '{DOMAIN01}/v1/insurance/business/applications',
        getCall: '{DOMAIN01}/v1/insurance/business/applications',
        getPollingQuotes: '{DOMAIN01}/v1/insurance/quote/{0}',
        personalDetailsCall: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/persons/{personCode}',
        getInsurerRelationshipCode: '{DOMAIN01}/v1/insurance/products/relationgroups/OMHLALLOWEDFMLY',
        modifyPlanInsuredData: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/products/quotes',
        mailingAddressService: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/addresses/{addressCode}',
        nomineesService: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/nominees',
        getSummaryDetails: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/summary',
        quoteCriteriaPut: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/appquotecriteria/put',
        quoteCriteria: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/appquotecriteria',
        getHeaderDetails: '{DOMAIN01}/v1/insurance/applications/{applicationId}/quotes/{quoteId}/headerdetail',
        getPolicy: '{DOMAIN01}/v1/insurance/applications/{applicationId}/quotes/{quoteId}/policies',
        emicardsTransactions: '{DOMAIN01}/v1/insurance/business/payments/emicards/transactions',
        postprocessingPayment: '{DOMAIN01}/v1/insurance/payments/pgateways/postprocessing',
        cancelPayment: '{DOMAIN01}/v1/insurance/payments/pgateways/cancel',
        emiOPTPost: '{DOMAIN01}/v1/insurance/business/payments/emicards/otp',
        retryPayment: '{DOMAIN01}/v1/insurance/business/payments/retry',
        ResumeLandingGetCall: '{DOMAIN01}/v1/insurance/business/session/{sessionId}/{prodCatCode}',
        ValidateOtp: '{DOMAIN01}/v1/otp/validate',
        GoToAppListing: '{DOMAIN01}/v1/insurance/business/redirect',
        // tslint:disable-next-line:max-line-length
        QuoteListingGetCall: '{DOMAIN01}/v1/insurance/business/applications/search?mobileNo={mobileNo}&productCategory={productCategory}&additionalParam={additionalParam}',
        GetQuoteList: '{DOMAIN01}/v1/insurance/ep/applications/{applicationId}/quotes',
        QuoteListingPostCall: '{DOMAIN01}/v1/insurance/business/redirect',
        CongratulationsData: '{DOMAIN01}/v1/insurance/policydoc/application/{applicationId}/quote/{quoteId}?quoteItemId={quoteItemId}',
        downloadPlanBrochure: '{DOMAIN01}/v1/insurance/business/products/variants/{variantcode}/brochure',
        downloadPlanBrochureAsset: '../../../assets/pdf/ABHI_Brochure.pdf',
        downloadPlanBrochureNew: '{DOMAIN01}/v1/insurance/business/brochure?variant={variantcode}',
        salutationDetails: '{DOMAIN01}/v1/insurance/business/principals/{principalKey}/master?apiName=Salutation',
        cashlessHospital: '{DOMAIN01}/v1/insurance/product/smartsearch/health/hospitals?principalKey={principalKey}&hospitalName={hospitalName}&cityKey={cityKey}&pincodeKey={pincodeKey}',
        postProductReview: '{DOMAIN01}/v1/insurance/business/renewal/redirect',
        saveCustomerJourneyData: '{DOMAIN01}/v1/insurance/business/payments/pgateways/initiate',
        ValidatePostOtp: '{DOMAIN01}/v2/login/forms/mobile',
        maritalStatusDetails: '{DOMAIN01}/v1/insurance/business/principals/{principalKey}/master?apiName=MaritalStatus',
        designationDetails: '{DOMAIN01}/v1/insurance/products/lookupcodes/HEALTH_DESIGNATION',
        educationDetails: '{DOMAIN01}/v1/insurance/products/lookupcodes/HEALTH_EDUCATION',
        occupationDetails: '{DOMAIN01}/v1/insurance/products/lookupcodes/HEALTH_OCCUPATION',
        medicalDeclarationService: '{DOMAIN01}/v1/insurance/business/products/{productCode}/quotes/{quoteId}/questions/{questionSetCode}',
        medicalDeclarationABHIService: '{DOMAIN01}/v2/insurance/business/products/{productCode}/quotes/{quoteId}/questions/{questionSetCode}',
        calculatePremiumforHealthRevamp: '{DOMAIN01}/v1/insurance/applications/quotes/refinement',
        getAllStatesApi: '{DOMAIN01}/v1/referencedata/allstates',
        getCitiesApi: '{DOMAIN01}/v1/referencedata/cities?stateKey=',
        getDocAndAppStatus: '{DOMAIN01}/v1/insurances/health/{applicationId}/status',
        getPlanSumAssured: '{DOMAIN01}/v1/bre/insurances/health/plans/sumassured',
        getPlanRiders: '{DOMAIN01}/v1/bre/insurances/health/plans/riders',
        getRepaymentPayload: '{DOMAIN01}/v1/nosqldata/audit?applicationId=',
        getMaritalStatusCodes: '{DOMAIN01}/v1/referencedata/maritalstatuscode',
        getCountry: '{DOMAIN01}/v1/referencedata/countries?countryName=',
        validatePan: '{DOMAIN01}/v1/insurances/validations/pan',
        postLeadType: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/leadtype/{leadType}',
        getOccupation: '{DOMAIN01}/v1/insurance/business/principals/{principalKey}/master?apiName=Occupation&prodCatgKey={productCategoryKey}',
        postOTPForReviewDetail: '{DOMAIN01}/v1/insurance/business/application/{applicationId}/quotes/{quoteId}/otpConsent',
        ValidatePostOtpForReviewDetails: '{DOMAIN01}/v1/insurance/business/application/{applicationId}/quotes/{quoteId}/otpConsent',
        resendOtpForReviewDetail: '{DOMAIN01}/v1/insurance/business/application/{applicationId}/quotes/{quoteKey}/consents/{consentkey}/otp',
        getPaymentStatusRoute: '{DOMAIN01}/v1/insurance/applications/{applicationId}/quotes/{quoteId}/summary?authtoken={authtoken}',
        sendEventStatus: '{DOMAIN01}/v1/insurance/business/applications/{applicationId}/quotes/{quoteId}/payments/status',
        rolloverPlanList: '{DOMAIN01}/v2/insurance/quickquote',
        sessionExtend: '{DOMAIN01}/v1/insurance/business/application/{applicationId}/session/put',
        sendQuotatioLinkService: '{DOMAIN01}/v1/insurance/employeeportal/appliation/notification',
        getProposerDetails: '{DOMAIN01}/v1/insurance/products/{health}/applications/{applicationId}/quotes/{quoteId}/proposer'
    };
    public static AEMURL = {
        HealthListAem: '{AEMURL}/api/assets/insurance-marketplace/insurance-mall-dj/healthinsuranceitems/HealthInsurancePlanListing.model.json',
        HealthListAembfdl: '{AEMURL}/api/assets/bajajfinserv/insurance/healthinsuranceitems/healthinsuranceplanlisitng.model.json'
    };
    public static PageTitles = {
        proposerPersonalDetails: 'Personal Details',
        mailingAddress: 'Mailing Address',
        verifyMobile: 'Verify Mobile',
        appSummary: 'appSummary'
    };
    public static CurrencyCoversionUnits = {
        Lacs: 100000,
        Crore: 10000000
    };
    public static SourceTypes = {
        System: 'system',
        Journey: 'journey',
        CustomerPortal: 'customerportal',
        EmployeePortal: 'employeeportal'
    };
    public static footerText = [
        {
            title: 'Bajaj finserv Direct limited',
            desc: '4TH Floor, B2 Building, Cerebrum IT Park, Kumar City, Kalyani Nagar, Pune – 411014.'
        }
        /* ,
        {
            title: 'Corporate Office',
            desc: '4TH Floor, B2 Building, Cerebrum IT Park, Kumar City, Kalyani Nagar, Pune – 411014.'
        } */
    ];
    public static EmitterEventTypes = {
        LoadingEvent: 'LoadingEvent',
        GlobalErrorEvent: 'GlobalErrorEvent',
        ProgressStateEvent: 'ProgressStateEvent',
        LoadingSmallLoaderEvent: 'SmallLoader',
        NavigationEvent: 'NavigationFlag',
        ProcessCallCompleteEvent: 'ProcessCallComplete',
        MobileAppCheck: 'MobileAppCheck',
        AadhaarOTPRequested: 'aadhaarOTPRequested',
        SessionExpired: 'SessionExpired'
    };
    public static errorCodes = [
        'OTP_801', 'OTP_802', 'OTP_803', 'OTP_804', 'OTP_805', 'OTP_806', 'OTP_807', 'OTP_808', 'OTP_809', 'OTP_810',
        'OTP_811', 'OTP_812', 'OTP_813', 'OTP_814', 'OTP_815', 'OTP_816', 'OTP_817', 'OTP_818', 'OTP_819', 'OTP_820'
    ];
    public static serviceError = [
        'APDM-201', 'APDM-204', 'APDM-203', 'APDM-202', 'OMIB-0008', 'OMIB-0009', 'PDM-842', 'PDM-844', 'PRIS-758', 'QDM-472'];
    public static offerAdds = {
        // tslint:disable-next-line:max-line-length
        healthInsuranceAdd: 'https://www.bajajfinservmarkets.in/insurance/health-insurance/family-health-insurance.html?pid=Web-Platforms:SPA:Health-SPA-MultiTab:Family-Health-Insurance:Banner:CrossSell',
        // tslint:disable-next-line:max-line-length
        UlipInsuranceAdd: 'https://www.bajajfinservmarkets.in/insurance/ulip/investment-plans.html?pid=Web-Platforms:SPA:Health-SPA-MultiTab:ULIP-Insurance:Banner:CrossSell',
        travelInsuranceAdd: '',
        motorInsuranceAdd: '',
        cyberInsuranceAdd: ''
    };
    public static DefaultHeightWeight = {
        height: 183,
        weight: 70
    };
    public static QuestionSetCode = {
        BAGIC: 'OMHL_MD',
        ABHI: 'ABHI_HMD',
        ABHIGRP: 'ABHI_GHMD',
        ABHIGHA: 'ABHI_GHMD',
        ABHILIFESTYLE: 'ABHI_LD',//todo
        ABHITOPUP: 'ABHITOPUP_GHMD',
        MANICIGIHP: 'MANIPRO_GHMD',
        MANICIGFHP: 'MANIPRO_GHMD',
        MANIPALCIGNA: 'MANICIG_GHMD',
        MAXBUPA: 'MAXGH_MD',
        ABHIGHA2: 'ABHI_GHMD',
        BFHL: 'BFHL_HMD',
        MAXBUPHCOM: 'MAXBUPHCOM_MD',
        MAXHRECHARG: 'MAXBUPHRECHARG_MD',
        MAXBUPHCOMLIFESTYLE: 'MAXBUPHCOM_LD',
        MAXHRECHARGLIFESTYLE: 'MAXBUPHRECHARG_LD',
        MAXBUPHCOMPASTPROPOSAL: 'MAXBUPHCOM_PHD',
        MAXHRECHARGPASTPROPOSAL: 'MAXBUPHRECHARG_PPD',
        MAXBUPHCOMFEMALE: 'MAXBUPHCOM_FMD',
        ABHIACTIVALIFESTYLE: 'ABHI_LD',
        MANICIGPH: 'MANICIGPH_MD',
        MANICIGPHACC: 'MANICIGPHACC_MD',
        MANICIGPHPLS: 'MANICIGPHPLS_MD',
        MANICIGPHPRF: 'MANICIGPHPRF_MD',
        MANICIGPHPRM: 'MANICIGPHPRM_MD',
        BAGICIHECP: 'OMHTP_MD',
        BAGICFHECP: 'OMHTP_MD',
        MANICIGSTOPUP: 'MANICIGSTOPUP_MD',
        BAGICGPGP: 'OMHGPGP_MD',
        CARE: 'CAREHI_MD',
        ABHIABCDHI: 'ABHIABCD_MD'

    };
    public static QuestionRejectionSet = [
        'BAGICIHG-QMD1-1',
        'BAGICHGFF-QMD1-1',
        'BAGICIGHP-QMD1-1',
        'BAGICFGHP-QMD1-1',
        'BAGICFGHP2-QMD1-1',
        'BAGICIGHP2-QMD1-1',
        'ABHIHG_QMD1',
        'ABHIHG_QMD2',
        'ABHIHG_QMD3',
        'ABHIHG_QMD4',
        'ABHIHG_QMD5',
        'ABHIGHA_QMD1_1_1',
        'ABHIGHA_QMD1_2_1',
        'ABHIGHA_QMD1_3_1',
        'ABHIGHA_QMD1_4_1',
        'ABHIGHA_QMD1_2_2',
        'ABHIGHA_QMD1_4_3',
        'ABHIGHA_QMD1_4_2',
        'ABHIGHA_QMD4',
        'MANICIGIGH_QMD1_1',
        'MANICIGIGH_QMD1_2',
        'MANICIGIGH_QMD1_3',
        'MANICIGIGH_QMD4',
        'MANICIGIGH_QMD1_4',
        'MANICIGIGH_QMD3',
        'MANICIGIGH_QMD2',
        'MANICIGGFH_QMD1_1',
        'MANICIGGFH_QMD4',
        'MANICIGGFH_QMD1_3',
        'MANICIGGFH_QMD3',
        'MANICIGGFH_QMD1_2',
        'MANICIGGFH_QMD2',
        'MANICIGGFH_QMD1_4',
        'ABHITOPUP_QMD1_2',
        'ABHITOPUP_QMD1_1',
        'ABHITOPUP_QMD1_4',
        'ABHITOPUP_QMD1_3',
        'ABHITOPUP_QMD2',
        'MAXGH_QMD_1',
        'BFHLVASCHSS_QMD1',
        'BFHLVASCHSS_QMD2',
        'BFHLVASCHSS_QMD3',
        'BFHLVASCHSS_QMD4',
        'BFHLVASCHSS_QMD5',
        'BFHLVASCHSS_QMD6',
        'BFHLVASCHSP_QMD1',
        'BFHLVASCHSP_QMD2',
        'BFHLVASCHSP_QMD3',
        'BFHLVASCHSP_QMD4',
        'BFHLVASCHSP_QMD5',
        'BFHLVASCHSP_QMD6',
        'BFHLVASCHSPP_QMD1',
        'BFHLVASCHSPP_QMD2',
        'BFHLVASCHSPP_QMD3',
        'BFHLVASCHSPP_QMD4',
        'BFHLVASCHSPP_QMD5',
        'BFHLVASCHSPP_QMD6',
        'BAGICIHG_QMD1_2',
        'BAGICIHG_QMD1_1',
        'BAGICHGFF_QMD1_1',
        'BAGICHGFF_QMD1_2',
        // 'BAGICFHECP_QMD1_5',
        'BAGICFHECP_QMD1_5_1',
        'ABHIHG_QMD2_1',//new codes
        'ABHIHG_QMD2_2',
        'ABHIHG_QMD2_3',
        'ABHIHG_QMD2_4',
        'ABHIHG_QMD2_5',
        'ABHIHG_QMD2_6',
        'ABHIHG_QMD2_7',
        'ABHIHG_QMD2_8',
        'ABHIHG_QMD2_9',

        'MANICIGFHP_QMD1_1',//'MANICIGFHP_QMD1'
        'MANICIGFHP_QMD1_2',
        'MANICIGFHP_QMD1_3',
        'MANICIGFHP_QMD1_4',
        'MANICIGFHP_QMD2',
        'MANICIGFHP_QMD3',
        'MANICIGFHP_QMD4',
        'MANICIGFHP_QMD5',
        'MANICIGFHP_QMD6',
        'MANICIGFHP_QMD7',
        'MANICIGIHP_QMD1_1',
        'MANICIGIHP_QMD1_2',
        'MANICIGIHP_QMD1_3',
        'MANICIGIHP_QMD1_4',
        'MANICIGIHP_QMD2',
        'MANICIGIHP_QMD3',
        'MANICIGIHP_QMD4',
        'MANICIGIHP_QMD5',
        'MANICIGIHP_QMD6',
        'MANICIGIHP_QMD7',
        'BAGICIHECP_QMD1_1',
        'BAGICIHECP_QMD1_2',
        'BAGICFHECP_QMD1_1',
        'BAGICFHECP_QMD1_2',
        'MANICIGPH_QMD5_1',
        'MANICIGPH_QMD5_2',
        'MANICIGSTOPUP_QMD5_2',
        'MANICIGSTOPUP_QMD5_1',
        'ABHIHG_QLD1_6',
        'CAREHI_QMD1',
        'CAREHI_QMD2',
        'CAREHI_QMD3',
        'CAREHI_QMD4',
        'CAREHI_QMD5',
        'MANICIGPH_QMD2_1',
        'MANICIGPH_QMD2_2',
        'MANICIGPH_QMD2_3',
        'MANICIGPH_QMD2_4',
        'MANICIGPH_QMD2_5',
        'MANICIGPH_QMD2_6',
        'MANICIGPH_QMD2_7',
        'MANICIGPH_QMD2_8',
        'MANICIGPH_QMD2_9',
        'MANICIGPH_QMD2_10',
        'MANICIGPH_QMD2_11',
        'MANICIGPH_QMD2_12',
        'MANICIGPH_QMD2_13',
        'MANICIGPH_QMD2_14',
        'MANICIGPH_QMD1',
        'MANICIGPH_QMD3',
        'MANICIGPH_QMD4',
        'MANICIGPH_QMD5',
        'MANICIGPH_QMD6',
        'MANICIGSTOPUP_QMD2_1',
        'MANICIGSTOPUP_QMD2_2',
        'MANICIGSTOPUP_QMD2_3',
        'MANICIGSTOPUP_QMD2_4',
        'MANICIGSTOPUP_QMD2_5',
        'MANICIGSTOPUP_QMD2_6',
        'MANICIGSTOPUP_QMD2_7',
        'MANICIGSTOPUP_QMD2_8',
        'MANICIGSTOPUP_QMD2_9',
        'MANICIGSTOPUP_QMD2_10',
        'MANICIGSTOPUP_QMD2_11',
        'MANICIGSTOPUP_QMD2_12',
        'MANICIGSTOPUP_QMD2_13',
        'MANICIGSTOPUP_QMD2_14',
        'MANICIGSTOPUP_QMD1',
        'MANICIGSTOPUP_QMD3',
        'MANICIGSTOPUP_QMD4',
        'MANICIGSTOPUP_QMD5',
        'MANICIGSTOPUP_QMD6',
        'ABHIABCD_QMD_1',

        'BAGICIHG_QMD1',
        'BAGICHGFF_QMD1',
        'BAGICFHECP_QMD1',
        'BAGICIHECP_QMD1',
    ];
    public static productCode = [
        'ABHIGHA2',
        'ABHITOPUP',
        'ABHIGHA',
        'MANICIGIHP',
        'MANICIGFHP',
        'MANICIGPH',
        'MANICIGPHACC',
        'MANICIGPHPLS',
        'MANICIGPHPRF',
        'MANICIGPHPRM',
        'MAXBUPHCOM',
        'MAXHRECHARG',
        'BAGICIHECP',
        'BAGICFHECP',
        'MANICIGSTOPUP',
        'BAGICGPGP',
        'ABHIABCDHI'
    ]
    public static PaylaterPartners = [
        'MAXBUPA',
        'MANIPALCIGNA',
        'BFHL',
        'CARE'
    ]
    public static regularFlowPartners = [
        'ABHI',
        'BAGIC',
        'MAXBUPA',
        'MANIPALCIGNA',
        'BFHL',
        'CARE'
    ]
    public static insuredLvlQuestionairre = [
        'ABHI',
        'MANIPALCIGNA',
        'MAXBUPA',
        'BFHL',
        'BAGIC',
        'CARE'
    ]
    public static REPOSITORY_LIST = [
        {
            title: 'CAMS',
            value: 'CAMS Repository Insurance Service'
        }, {
            title: 'CDSL',
            value: 'CDSL Repository Insurance Service'
        }, {
            title: 'NSDL',
            value: 'NSDL Repository Insurance Service'
        }, {
            title: 'KARVY',
            value: 'KARVY Repository Insurance Service'
        }
    ]
    public static manipal_retail = [
        'MANICIGPH',
        'MANICIGPHACC',
        'MANICIGPHPLS',
        'MANICIGPHPRF',
        'MANICIGPHPRM',
        'MANICIGSTOPUP'
    ]
    public static addition_partners_Fields = [
        'MANICIGPH',
        'MANICIGSTOPUP',
        'MAXBUPHCOM',
        'MAXHRECHARG'
    ]
    public static custom_watermark = [
        'MANICIGPH_QMD5_3_1',
        'MANICIGSTOPUP_QMD5_3_1'

    ]
    public static restrictDecimalQuestionSetCode = [
        'ABHIHG_QLD1_1_1',
        'ABHIHG_QLD1_2_1',
        'ABHIHG_QLD1_3_1',
        'ABHIHG_QLD1_4_1',
        'ABHIHG_QLD1_5_1'
    ]
    public static vasProducts = [
        'BFHLVASCHSS',
        'BFHLVASCHSP'
    ]
    public static manipalGroup = [
        'MANICIGIHP',
        'MANICIGFHP',
        'MANICIGGFH',
        'MANICIGIGH'
    ]
    public static platforms = {
        ios: 'ios',
        android: 'android'
    };
    public static validateOtpErrorCodes: any = [
        'QDM-516', 'QDM-518'
    ];

    public static SsoConstants = {
        'CIPHER_KEY': '5u8x/A%D*Gv9y$B&',
        'CUSTOMER_DEDUPE_API': '/v1/insurance/business/customerdedupe',
        'BusinessServiceLoginURL': '/v1/insurance/business/federatedlogin',
        'ReverseBusinessServiceLoginURL': '/v1/insurance/business/federatedlogin/reverse',
        'MOTOKEN_VALIDATION_API': '/v1/insurance/business/moauthlogin'
    };
    public static utmSources = {
        organic: 'Organic'
    };

    public static routeHandler = {
        'organic': 'Organic'
    };
    public static bflHomePageUrl = 'https://www.bajajfinserv.in'

    public static navigation = {
        'prod:bfl': 'https://www.bajajfinserv.in/marketplace/insurance/health-insurance/health-insurance-premium-calculator/getGoingNow',
        'ppd:bfl': 'https://bfl-ppdmkp.bajajfinserv.in/marketplace/insurance/health-insurance/health-insurance-premium-calculator/getGoingNow',
        'uat:bfl': 'https://bfl.n2p.bfsgodirect.com/marketplace/insurance/health-insurance/health-insurance-premium-calculator/getGoingNow'
    };

    //Explore button redirection url
    public static bajajFinservUrl = 'https://www.bajajfinserv.in/insurance'
}
